import { ReactNodeLike } from "prop-types";

import { AssignmentsProvider } from "@/assignments/useAssignmentsGet";
import { ClassroomsProvider } from "@/classrooms/useClassroomsContext";
import { ReadAloudContextProvider } from "@/view/ReadAloudControls/useReadAloudMode";
import { AccessibilityControlsContextProvider } from "@/view/utils/useAccessibilityControlsContext";
import { ActivityPanelContextProvider } from "@/view/utils/useActivityPanel/useActivityPanel";
import { AssignmentReducerProvider } from "@/view/utils/useAssignmentReducerContext";
import { AttachmentsContextProvider } from "@/view/utils/useAttachmentsContext";
import { FocusManagerContextProvider } from "@/view/utils/useFocusManager";
import { PresentModeContextProvider } from "@/view/utils/usePresentModeContext";
import { StudentPreviewContextProvider } from "@/view/utils/useStudentPreviewContext/useStudentPreviewContext";
import { UserContentUIContextProvider } from "@/view/utils/useUserContentUIContext";
import { VideoEventBusContextProvider } from "@/view/utils/useVideoEventBus";

interface UnlevelledContentProviderProps {
  contentId: string;
  children: ReactNodeLike;
  contentType: string;
  isBannerModeActive: boolean;
  isLiteContent: boolean;
  isPremiumContent: boolean;
}

const UnlevelledContentProviders = ({
  contentId,
  children,
  contentType,
  isBannerModeActive,
  isLiteContent,
  isPremiumContent,
}: UnlevelledContentProviderProps) => {
  return (
    <FocusManagerContextProvider>
      <VideoEventBusContextProvider>
        <PresentModeContextProvider
          contentType={contentType}
          isBannerModeActive={isBannerModeActive}
        >
          <ReadAloudContextProvider>
            <AssignmentsProvider>
              <AssignmentReducerProvider>
                <UserContentUIContextProvider
                  isLiteContent={isLiteContent}
                  isPremiumContent={isPremiumContent}
                >
                  <ActivityPanelContextProvider>
                    <AccessibilityControlsContextProvider>
                      <StudentPreviewContextProvider>
                        <AttachmentsContextProvider contentId={contentId}>
                          <ClassroomsProvider>{children}</ClassroomsProvider>
                        </AttachmentsContextProvider>
                      </StudentPreviewContextProvider>
                    </AccessibilityControlsContextProvider>
                  </ActivityPanelContextProvider>
                </UserContentUIContextProvider>
              </AssignmentReducerProvider>
            </AssignmentsProvider>
          </ReadAloudContextProvider>
        </PresentModeContextProvider>
      </VideoEventBusContextProvider>
    </FocusManagerContextProvider>
  );
};

export default UnlevelledContentProviders;
